import classNames from 'classnames';
import React from 'react';

const IconClose = ( props ) => {
	const { fill = 'charcoal', size = 'base' } = props;
	const fillClass = classNames( {
		'tw-fill-charcoal': fill === 'charcoal',
		'tw-fill-slate': fill === 'slate',
		'tw-fill-steel group-hover:tw-fill-slate': fill === 'steel',
	} );

	const sizeClass = classNames( {
		'tw-w-2 tw-h-2': size === 'sm',
		'tw-w-4 tw-h-4': size === 'base',
	} );

	return (
		<svg className={sizeClass} aria-hidden="true" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path className={fillClass} d="M1.60865 14.0002L0.5 12.8916L6.39135 7.00021L0.5 1.10887L1.60865 0.000213623L7.5 5.89156L13.3913 0.000213623L14.5 1.10887L8.60865 7.00021L14.5 12.8916L13.3913 14.0002L7.5 8.10887L1.60865 14.0002Z" />
		</svg>
	);
};

export default IconClose;
